function topScroll() {
  if (window.scrollY > 200) {
    document.querySelector('#main').classList.add('is-scrolled-off-top');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-off-top');
  }
}

function runScrollFunctions() {
  topScroll();
}

document.addEventListener('scroll', function (e) {
  runScrollFunctions();
});

document.addEventListener('DOMContentLoaded', () => {
  runScrollFunctions();
});
